var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.2903 35L35 63.1122",
    stroke: "#4E7661",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1562 47.9424V22.0575C60.1562 21.6702 60.0534 21.2897 59.8582 20.9551C59.6629 20.6205 59.3824 20.3438 59.0451 20.1532L36.0764 7.17084C35.748 6.98523 35.3772 6.8877 35 6.8877C34.6228 6.8877 34.252 6.98523 33.9236 7.17084L10.9549 20.1532C10.6176 20.3438 10.3371 20.6205 10.1418 20.9551C9.94662 21.2897 9.84375 21.6702 9.84375 22.0575V47.9424C9.84375 48.3298 9.94662 48.7102 10.1418 49.0448C10.3371 49.3794 10.6176 49.6561 10.9549 49.8467L33.9236 62.8291C34.252 63.0147 34.6228 63.1122 35 63.1122C35.3772 63.1122 35.748 63.0147 36.0764 62.8291L59.0451 49.8467C59.3824 49.6561 59.6629 49.3794 59.8582 49.0448C60.0534 48.7102 60.1563 48.3298 60.1562 47.9424V47.9424Z",
    stroke: "#4E7661",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8566 20.9527L35.2904 35L10.1454 20.9497",
    stroke: "#4E7661",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.997ac8dd6b25c4f60764da3293394d70.svg";
export { ForwardRef as ReactComponent };